module.exports = __webpack_public_path__ + "static/img/faqs.66ba6e1c.jpg";